import { format } from 'date-fns';
/* eslint-disable @typescript-eslint/consistent-type-definitions */
export type JSONTabularData = { [header: string]: string | number };

export interface TabularData {
  date: string;
  fields: Array<string>;
  headers: Array<string>;
  data: Array<Array<string | number>>;
}

export function factoryTabularData(template: Partial<TabularData> = {}) {
  if (!template.date) {
    template.date = format(new Date(), 'E MMM dd yyyy hh:mm:ss OOOO');
  }
  if (!template.headers) {
    template.headers = [];
  }
  if (!template.data) {
    template.data = [];
  }

  return template as TabularData;
}
